import {useNavigate} from 'react-router-dom';
import {ChatRoomsEnum, ExamBookingEnum, QueryParamsEnum} from 'presentation/constants';
import {useCallChatRoom, useMediaQueries, useQueryParams} from 'presentation/pages/private/hooks';
import {useHostName} from 'presentation/hooks';
import {useOpenOptionsDrawerStore} from 'presentation/pages/private/store/useOpenOptionsDrawer';
import {usePpoNetworkStore} from 'presentation/modules/guide/shared/store/guideStore/usePpoNetworkStore';
import {translations} from 'presentation/translations-new';
import {OptionsDrawerItem} from 'presentation/pages/private/home/components/OptionsDrawer/types';
import {ppoNetworkTypeEnum} from 'presentation/modules/guide/shared/store/guideStore/types';

const {accreditedNetwork} = translations['pt-br'].privateFlow.home.portalShortcutLabels;
const {proprietaryNetwork, serviceNetwork} = translations['pt-br'].privateFlow.services;

export function useExamEmptyState() {
	const {SEARCH_PARAMS} = useQueryParams();
	const {query} = SEARCH_PARAMS;

	const {isMobile} = useMediaQueries();
	const navigate = useNavigate();

	const {isNotredameSaude} = useHostName();
	const {openOptionsDrawer, closeOptionsDrawer} = useOpenOptionsDrawerStore();

	const setPpoNetworkType = usePpoNetworkStore(state => state.setPpoNetworkType);

	const examBookingProcedureSelectionRoute = `${ExamBookingEnum.EXAM_BOOKING_PROCEDURE_SELECTION}?${QueryParamsEnum.SEARCH_QUERY}=${query}`;

	const ONLY_NETWORK_OPTIONS: (OptionsDrawerItem & {show: boolean})[] = [
		{
			label: accreditedNetwork,
			icon: 'pin-drop-filled',
			onClick: () => {
				setPpoNetworkType(ppoNetworkTypeEnum.ACCREDITED_NETWORK);
				closeOptionsDrawer();

				navigate(examBookingProcedureSelectionRoute);
			},
			show: true,
		},
		{
			label: proprietaryNetwork,
			icon: 'notredame-logo',
			onClick: () => {
				setPpoNetworkType(ppoNetworkTypeEnum.SELF_NETWORK);
				closeOptionsDrawer();

				navigate(examBookingProcedureSelectionRoute);
			},
			show: true,
		},
	];

	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();

	const handleCallChatRoom = async () => {
		await callChatRoom(ChatRoomsEnum.EXAMS);
	};

	const handleGoToProcedureSelection = () => {
		if (isNotredameSaude) {
			openOptionsDrawer(serviceNetwork, ONLY_NETWORK_OPTIONS);

			return;
		}

		navigate(examBookingProcedureSelectionRoute);
	};

	return {
		isMobile,
		callChatRoomIsLoading,
		handleCallChatRoom,
		handleGoToProcedureSelection,
	};
}
